"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitRtlProps = exports.parseSides = exports.makeKeyRtlSafe = void 0;
var _parseCssValue = require("../../utils/parseCssValue");
var _excluded = ["margin", "padding"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
// inspired by: https://github.com/jednano/parse-css-sides/blob/master/src/index.ts
var createSides = function createSides(top) {
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : top;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : top;
  var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : right;
  // eslint-disable-next-line @atg/css-rtl-support
  return {
    bottom: bottom,
    left: left,
    right: right,
    top: top
  };
};
var parseSides = exports.parseSides = function parseSides(value) {
  var sides = value.split(" ");
  var _sides = _toArray(sides),
    first = _sides[0],
    rest = _sides.slice(1);
  return createSides.apply(void 0, [first].concat(_toConsumableArray(rest)));
};
var SIDES = ["Top", "Right", "Bottom", "Left"];
var splitRtlProps = exports.splitRtlProps = function splitRtlProps(params) {
  var margin = params.margin,
    padding = params.padding,
    rest = _objectWithoutProperties(params, _excluded);
  var marginString = (0, _parseCssValue.parseCssValue)(margin, "margin");
  if (marginString) {
    var marginValues = parseSides(marginString);
    for (var _i = 0, _SIDES = SIDES; _i < _SIDES.length; _i++) {
      var side = _SIDES[_i];
      if (typeof rest["margin".concat(side)] === "undefined") {
        rest["margin".concat(side)] = marginValues[side.toLowerCase()];
      }
    }
  }
  var paddingString = (0, _parseCssValue.parseCssValue)(padding, "padding");
  if (paddingString) {
    var paddingValues = parseSides(paddingString);
    for (var _i2 = 0, _SIDES2 = SIDES; _i2 < _SIDES2.length; _i2++) {
      var _side = _SIDES2[_i2];
      if (typeof rest["padding".concat(_side)] === "undefined") {
        rest["padding".concat(_side)] = paddingValues[_side.toLowerCase()];
      }
    }
  }
  return rest;
};
var makeKeyRtlSafe = exports.makeKeyRtlSafe = function makeKeyRtlSafe(key) {
  if (key === "left") {
    return "insetInlineStart";
  }
  if (key === "right") {
    return "insetInlineEnd";
  }
  // for now leave borders alone
  if (!key.includes("margin") && !key.includes("padding")) {
    return key;
  }
  if (key.endsWith("Left")) {
    return key.replace("Left", "InlineStart");
  }
  if (key.endsWith("Right")) {
    return key.replace("Right", "InlineEnd");
  }
  return key;
};